module.exports = __webpack_public_path__ + "img/logo_2022-super-bowl.dbcdcfb5.png";